import React from "react";
import styled from "@emotion/styled";

const Container = styled.div`
  padding: 16px;
  background-color: #1c1c1c;
  border-radius: 6px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const TextContainer = styled.div`
  margin-right: 33px;
  h4 {
    margin: 0;
    font-family: "Gilroy";
    font-weight: bold;
    margin-bottom: 24px;
    color: white;
  }
  p {
    color: white;
  }
`;

const VoteIcon = styled.div`
  display: flex;
  align-items: center;
`;

export default function LostYourBraceletCard() {
  return (
    <Container>
      <TextContainer>
        <h4>VOTE FOR YOUR FAVOURITE EXHIBITOR</h4>
        <p>Help them win!</p>
      </TextContainer>
      <VoteIcon>
        <svg
          width="53"
          height="62"
          viewBox="0 0 53 62"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M8.15385 22H44.879L53 35H0L8.15385 22Z" fill="#EF4E55" />
          <path d="M11 27H42L43 30H10L11 27Z" fill="black" />
          <rect
            width="23.0181"
            height="26.2184"
            transform="matrix(0.567489 0.823381 -0.670364 0.742032 30.8257 0)"
            fill="#F6F6F2"
          />
          <rect x="10" y="30" width="33" height="32" fill="#EF4E55" />
          <rect y="35" width="53" height="27" fill="#BD3D44" />
        </svg>
      </VoteIcon>
    </Container>
  );
}
